import { bool, number, oneOfType, string } from 'prop-types';
import React from 'react';
import checkMark from '../../assets/svg/icon-check-mark-green.svg';
import {
  ErrorMessage,
  InputFieldDescription,
  InputFieldTitle,
  InputFieldWrapper,
  InputSpacing,
  SCInputField,
} from './styles';

function InputField({
  title,
  description,
  isValid,
  isInValid,
  isDirty,
  error,
  value,
  ...rest
}) {
  const isError = Boolean(isDirty && isInValid);
  let defaultValue = '';
  if ((value !== 'null' && Boolean(value)) || value === 0) {
    defaultValue = value;
  }

  return (
    <InputSpacing>
      <InputFieldTitle>{title}</InputFieldTitle>
      {description && (
        <InputFieldDescription>{description}</InputFieldDescription>
      )}
      <InputFieldWrapper valid={isValid} error={isError} svg={checkMark}>
        <SCInputField value={defaultValue} {...rest} />
      </InputFieldWrapper>
      {isError && <ErrorMessage>{error}</ErrorMessage>}
    </InputSpacing>
  );
}

InputField.propTypes = {
  description: string,
  error: string,
  isDirty: bool,
  isInValid: bool,
  isValid: bool,
  name: string.isRequired,
  title: string.isRequired,
  value: oneOfType([string, bool, number]),
};

InputField.defaultProps = {
  description: '',
  error: '',
  isDirty: false,
  isInValid: true,
  isValid: false,
  value: '',
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/InputField/InputField.js